<template>
    <div class="banner">
        <swiper :options="swiperOption" ref="mySwiper">
            <!-- pc slides -->
            <swiper-slide v-if="platform == 1" v-for="item in pc_banner" :key="item.url">
                
                <!-- <a class="banner_btn" :href="item.url2" :style="{top: item.top+'px', marginLeft: item.left1+'px'}">进一步了解</a> -->
                <!-- <a class="banner_btn" v-if="item.left2" :href="item.url1 || item.url2" :style="{top: item.top+'px', marginLeft: item.left2+'px'}">立即选购</a> -->
                <a :href="item.url2">
                    <img :src="item.imgPath" width="100%" />
                </a>
            </swiper-slide>
            <!-- mobile sliders -->
            <swiper-slide v-if="platform != 1" v-for="item in mobile_banners" :key="item.url">
                <a :href="item.url">
                <img :src="item.imgPath" width="100%" />
                </a>
            </swiper-slide>
            <div class="swiper-pagination"  slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"><i></i></div>
            <div class="swiper-button-next" slot="button-next"><i></i></div>
        </swiper>
    </div>
</template>
<script>
    // import Vue from 'vue'
    // import VueAwesomeSwiper from 'vue-awesome-swiper'
    import BannerBusiness from "./banner_business.vue"
    
    import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'

    //注册swiper插件
    //Vue.use(VueAwesomeSwiper)

    export default {
        components: {
            swiper,
            swiperSlide,
            BannerBusiness
        },
        data() {
            return {
                platform: 1, //1 pc端   2 mobile端
                pc_banner: [{
                    imgPath: require("../assets/img/banner/pc/h2.jpg"),
                    url2: "/product/h2",
                },{
                    imgPath: require("../assets/img/banner/pc/h5.jpg"),
                    url2: "/product/h5",
                },{
                    imgPath: require("../assets/img/banner/pc/w10.jpg"),
                    url2: "/product/w10",
                },{
                    imgPath: require("../assets/img/banner/pc/w11.jpg"),
                    url2: "/product/w11",
                },{
                    imgPath: require("../assets/img/banner/pc/x3.jpg"),
                    url2: "/product/x3",
                },{
                    imgPath: require("../assets/img/banner/pc/w9.jpg"),
                    url2: "/product/w9",
                    left1: 288,
                    // left2: -222,
                    top: 426,
                },{
                    imgPath: require("../assets/img/banner/pc/w0.jpg"),
                    url2: "/product/w0",
                    left1: 238,
                    // left2: -222,
                    top: 420,
                }],
                mobile_banners: [{
                    imgPath: require("../assets/img/banner/mobile/h2.jpg"),
                    url: "/product/h2"
                },{
                    imgPath: require("../assets/img/banner/mobile/h5.jpg"),
                    url: "/product/h5"
                },{
                    imgPath: require("../assets/img/banner/mobile/w10.jpg"),
                    url: "/product/w10"
                },{
                    imgPath: require("../assets/img/banner/mobile/w11.jpg"),
                    url: "/product/w11"
                },{
                    imgPath: require("../assets/img/banner/mobile/x3.jpg"),
                    url: "/product/x3"
                },{
                    imgPath: require("../assets/img/banner/mobile/w9.jpg"),
                    url: "/product/w9"
                },{
                    imgPath: require("../assets/img/banner/mobile/w0.jpg"),
                    url: "/product/w0"
                }
                 ],
                swiperOption: {
                    // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                    notNextTick: true,
                    // swiper configs 所有的配置同swiper官方api配置
                    autoplay: 3000,
                    grabCursor: true,
                    setWrapperSize: true,
                    autoHeight: true,
                    pagination: '.swiper-pagination',
                    prevButton: '.swiper-button-prev',
                    nextButton: '.swiper-button-next',
                    paginationClickable: true,
                    loop: true,
                    // mousewheelControl : true,
                    observeParents: true,
                    // if you need use plugins in the swiper, you can config in here like this
                    // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                    debugger: true,
                    // swiper callbacks
                    // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
                    onTransitionStart(swiper) {
                        //console.log(swiper)
                    },
                    // more Swiper configs and callbacks...
                    // ...
                }
            }
        },
        mounted() {
            if ($(window).width() > 786) {
                this.platform = 1;
            } else {
                this.platform = 2;
            }
        }
    }
</script>
<style scoped>
    .swiper-button-next,
    .swiper-container-rtl .swiper-button-prev {
        background-image: none;
        /* left: 50%;
        margin-left: 700px; */
        right: 80px;
    }
    
    .swiper-button-prev,
    .swiper-container-rtl .swiper-button-next {
        background-image: none;
        /* left: 50%;
        margin-left: -764px; */
        left: 80px;
    }
    
    .swiper-button-next i,
    .swiper-container-rtl .swiper-button-prev i {
        background-image: url(../assets/img/icons/banner-arrow-right.png);
    }
    
    .swiper-button-prev i,
    .swiper-container-rtl .swiper-button-next i {
        background-image: url(../assets/img/icons/banner-arrow-left.png);
    }
    
    .swiper-button-prev,
    .swiper-button-next {
        padding: 17px;
        width: 64px;
        height: 64px;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.4);
        display: none;
    }
    
    .swiper-container:hover .swiper-button-prev,
    .swiper-container:hover .swiper-button-next {
        display: block;
    }
    
    .swiper-button-prev i,
    .swiper-button-next i {
        width: 30px;
        height: 30px;
        display: block;
        background-repeat: no-repeat;
        background-position: center;
    }
    
    .banner {
        margin-top: 80px;
    }

    .banner_btn{
        width: 126px;
        height: 34px;
        border: none;
        position: absolute;
        left: 50%;
        display: block;
        opacity: 0;
    }
    
    .swiper-slide {
        overflow: hidden;
        position: relative;
    }
    
    .swiper-slide img {
        width: 100%;
        /* height: 1000px; */
        /* width: 100%; */
        height: auto;
        position: relative;
        left: 50%;
        transform: translate(-50%, 0);
    }
    
    @media (max-width: 768px) {
        .banner {
            margin-top: 60px;
        }
        .swiper-slide img {
            height: auto;
            width: 100%;
        }
        .swiper-container:hover .swiper-button-prev,
        .swiper-container:hover .swiper-button-next {
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/banner.vue